// extracted by mini-css-extract-plugin
module.exports = {"logoPlaceholder":"t8omTE2F","iconWrap":"siXkGK4T","cryptoImage":"ir1C99bK"};